<template>
  <div>
    <div class="upload-instructions">
      <p>{{ $t("organizations.invite_users.import.instructions2") }}</p>
      <a :href="isOrgUseDummyEmail ? '/files/Dummy-Userlist.xlsx' : '/files/ELSA-Userlist.xlsx'" download>{{
        $t("organizations.invite_users.import.get_template_xlsx")
      }}</a>
      <p>{{ $t("common.or") }}</p>
      <a :href="isOrgUseDummyEmail ? '/files/Dummy-Userlist.csv' : '/files/ELSA-Userlist.csv'" download>{{
        $t("organizations.invite_users.import.get_template_csv")
      }}</a>
      <p :style="{ 'margin-left': '0px' }">,</p>
      <p :style="{ 'margin-left': '0px' }">{{ $t("organizations.invite_users.import.instructions3") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadInstuctions",
  data() {
    return {};
  },
  props: {
    isOrgUseDummyEmail: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped></style>
